import { useEffect } from 'react';

import { usePreviewModeDataContext } from 'contexts/PreviewModeDataContext/index';

/**
 * Handles disabling actions when the app is on preview mode
 * Added as a component since Online Ordering App component is still
 * a class component base that does not support hooks
 */
const PreviewModeManager = () => {
  const { isPreview } = usePreviewModeDataContext();

  const previewClickHandler = event => {
    const { target } = event;
    const allowPreview = target.getAttribute('data-allow-preview') === 'true';

    if (allowPreview) {
      return;
    }

    event.preventDefault();
  };

  useEffect(() => {
    if (isPreview) {
      document.addEventListener('click', previewClickHandler);

      return () => {
        document.removeEventListener('click', previewClickHandler);
      };
    }
  }, [isPreview]);

  return null;
};

export default PreviewModeManager;
